/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5036f499acd0267732b63ef9f300098d32d80106";
